module.exports = __webpack_public_path__ + "static/media/simlogo.1f750e80.svg";